var giphy_viewer_default = {
  "giphyWrapper": "_3OM0r",
  "giphy_player": "Yu4kY",
  "playIcon": "br4em",
  "gifRatio": "VpLE6"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
